import * as React from 'react';
import * as styles from './RegionSelect.css';
import { LinksButton } from '../LinksButton';

export interface IRegionSelectProps {
  regionName: string;
  openPopup(): void;
  popupIsOpen: boolean;
  geoModal: JSX.Element;
}

export const RegionSelect: React.FC<IRegionSelectProps> = ({ regionName, openPopup, popupIsOpen, geoModal }) => {
  return (
    <section className={styles['container']}>
      Регион поиска:
      <button className={styles['button']} onClick={openPopup}>
        {regionName}
      </button>
      {popupIsOpen && geoModal}
      <LinksButton />
    </section>
  );
};
